import React from 'react';
import {useSelector} from 'react-redux';

import PopularDestinationsUI from '../../../../stories/components/hotels/HomePage/PopularDestinationsUI/PopularDestinationsUI';
import {SegmentSliderLoader} from '../../../../stories/components/hotels/HomePage/SegmentSlider/SegmentSliderHotelCardLoader/SegmentSliderHotelCardLoader.styles';
import {destinationsSelectorFn} from '../destinations-redux/selectors';
import {pushga} from 'ga-utils';
import {HomePageGAEvents} from '../../../config/ga-config';

const PopularDestinations = () => {
  const {data: destinationsFromState, isLoading: isDestinationsLoading} = useSelector(
    destinationsSelectorFn,
  );

  if (isDestinationsLoading) return <SegmentSliderLoader />;

  if (!destinationsFromState) return null;

  const gaHandler = val => {
    pushga({
      eventCategory: HomePageGAEvents.hotelHomePageClicks.category,
      eventAction: HomePageGAEvents.popularDestinationsClicked,
      eventLabel: val.h_text,
    });
  };

  return (
    <PopularDestinationsUI destinationsFromState={destinationsFromState} gaHandler={gaHandler} />
  );
};

export default PopularDestinations;
